<template>
  <div class="modal fade show" id="therapistRegistrationModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" id="therapistRegistration">

        <div class="modal-header px-4 pt-4 pb-0 border-0">
          <h1 class="display-3">
            <span v-if="step < 2">Registrujte se k praktickému lékaři</span>
            <span v-else>Hotovo</span>
          </h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-4">
          <div v-if="step === 1">
            <form ref="stepForm" @submit.prevent="submitHandler()">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="fname"
                           class="form-control form-control-lg"
                           v-model.trim="user.firstName"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="fname">
                        <span>
                            Jméno
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="lname"
                           class="form-control form-control-lg"
                           v-model.trim="user.lastName"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="lname">
                        <span>
                            Příjmení
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="email"
                           id="mail"
                           class="form-control form-control-lg"
                           v-model.trim="user.email"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="mail">
                        <span>
                            E-mail
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="phone"
                           class="form-control form-control-lg"
                           v-model.trim="user.phone"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="phone">
                        <span>
                            Telefon
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <select class="form-control custom-select custom-select-lg" id="clinics" v-model="user.selectedClinicId" required>
                      <option value="" selected disabled hidden></option>
                      <option v-for="clinic in clinics" :value="clinic.Id" :key="clinic.Id">
                        {{ clinic.Name }}
                      </option>
                    </select>
                    <label class="label-floating" for="clinics">
                        <span>
                            Vyberte kliniku
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="birthday"
                           class="form-control form-control-lg"
                           v-model.trim="user.birthDate"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="birthday">
                        <span>
                            Datum narození
                        </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="custom-control custom-checkbox mb-2">
                <input type="checkbox" class="custom-control-input" id="consentUsage" required>
                <label class="custom-control-label" for="consentUsage">
                  Souhlasím s <a :href="consentUsageLink" target="_blank">podmínkami užití služby</a>
                </label>
              </div>
              <div class="custom-control custom-checkbox mb-4">
                <input type="checkbox" class="custom-control-input" id="consentGDPR" required>
                <label class="custom-control-label" for="consentGDPR">
                  Seznámil jsem se s <a :href="consentGdprLink" target="_blank">Informacemi o ochraně osobních údajů</a> a beru je na vědomí
                </label>
              </div>
              <div class="text-right">
                <button class="btn btn-secondary btn-lg" type="submit" role="button" :disabled="formSending">{{ formSending ? 'Odesílám...' : 'Dokončit' }}</button>
              </div>
            </form>
          </div>
          <div v-if="step === 2">
            <p class="pb-3">Do dvou pracovních dní se vám ozveme telefonicky nebo e-mailem s návrhem termínu vstupní prohlídky.</p>
            <p class="pb-3">Registrace k praktickému lékaři je platná až po podpisu registračního listu, který obdržíte při vstupní prohlídce.</p>
            <p class="pb-3">Děkujeme za důvěru a těšíme se na vás!</p>
            <button class="btn btn-secondary btn-lg" type="button" role="button" data-dismiss="modal" aria-label="Close">Hotovo</button>
          </div>
        </div>
        <div class="bg-light p-4 border-0" v-if="step < 2">
          <div class="row">
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-file-alt-regular-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Přechod od současného lékaře vyřídíme za vás</p>
              </article>
            </div>
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-user-nurse-solid-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Mnoho odborností v rámci jedné kliniky
                  zařízení</p>
              </article>
            </div>
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-clock-regular-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Objednáváme na čas, méně čekáte</p>
              </article>
            </div>
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-virus-solid-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Vystavujeme COVID žádanky</p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    // !!! if you are changing values below, change RESET values in mounted() as well
    consentUsageLink: '',
    consentGdprLink: '',
    user: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      birthDate: '',
      selectedClinicId: ''
    },
    clinics: [],
    step: 1,
    formSending: false
  }),
  mounted() {
    this.fetchClinics();

    // links to consent files from data atributes
    this.consentUsageLink = $('#therapistRegistrationModalComponent').data('consent-usage');
    this.consentGdprLink = $('#therapistRegistrationModalComponent').data('consent-gdpr');

    // focus fix for modal inputs
    let pageScroll = 0; 
    $("#therapistRegistrationModal").on('show.bs.modal', () => {
      // when modal is opened, go to top of page
      pageScroll = $(window).scrollTop();
      window.scroll({
          top: 0
      }); 
    });
    $("#therapistRegistrationModal").on('hide.bs.modal', () => {
      // when it's closed, return back
      window.scroll({
          top: pageScroll
      });
    });
    // --- focus fix for modal inputs ---

    $("#therapistRegistrationModal").on('hidden.bs.modal', () => {
        // RESET form when modal is closed
        this.step = 1;
        this.formSending = false;
        this.user = {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          birthDate: '',
          selectedClinicId: ''
        }
    });
  },
  methods: {
    fetchClinics() {
      const url = '/umbraco/api/GeneralPractitionerRegistration/GetClinics';
      axios
          .get(url)
          .then(response => {
            const { data } = response;
            this.clinics = data;
          })
          .catch(error => console.log(error))
          .finally(() => {
          });
    },
    submitHandler() {
      this.formSending = true;

      const url = '/umbraco/api/GeneralPractitionerRegistration/PostRegistrationForm';
      const data = this.user;
      axios
          .post(url, data)
          .then(response => {
            // send ga
            dataLayer.push({ 
              'event': 'ga.event', 
              'eventData': { 
                'category': 'Formular', 
                'action': 'Registrace k praktickemu lekari', 
                'label': 'Odeslan', 
                'value': 0 
              } 
            });

            // increase step
            this.step++;
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.formSending = false;

            // reset form data
            this.user = {
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              birthDate: '',
              selectedClinicId: ''
            }
          });
    },
  },
}

</script>
